import React from 'react'

const ChapterText = ({ children }) => {
  return <div style={{ overflowY: 'scroll', maxHeight: '73vh' }}>{children}</div>
}

export const Texts = {
  en: {
    mine: (
      <ChapterText>
        Tania Agapova, head of the surface technological unit, Toretska mine, Toretsk city
        <br />
        <br />
        <br />
        Our favorite places in the city? I don't have one, I love my city, and I don't have a favorite place. But that’s
        after that already. Because you can come, yes, and be alone with your thoughts. One man told me, well, if you
        passed by, there is a sign now saying, “Toretsk is the city of miners." So, he says: "I go up there early in the
        morning, sit down. It’s silent, some stream is there."
        <br />
        <br />I am like that, I like to be in a forest, at any time of the year. Even in the fall, like in the song by
        the “DDT” band, "What is autumn? It is the sky." It is to scatter everything. Well, that is, any nature is good
        for me, the main thing is that I take energy from nature.
        <br />
        <br />
        Here I am sitting at home. I understand that I feel bad. This is very, very rare. Somehow, all problems come at
        once, and that's it. And here I am sitting at home, trapped within four walls, well, I want something, and then
        I rush to nature. We have this place; it is called Deleevka. There are ponds; there are such coniferous trees
        around, and some deciduous trees. Among these conifers, there, you need to know the place, there are birches.
        Among all this, there are birches. It is so beautiful that it hurts a bit. And now, I found these places for
        myself. For example, I called, I called a taxi, I told the taxi driver: “You close the windows and wait. If I
        scream, I will not drown myself, that’s it, don’t worry. Let me just be there, then open the windows, that's
        it,” I said.
        <br />
        <br /> I mean, it happens, here is the last drop. Some trifle. Here I was walking, everything is very bad, I
        walked, stumbled, and that's all, and this, for example, is the last drop. Damn, on top of this, I stumbled
        there and hit a toe. Well, there is some last drop, this is something, and everything rushes on you. Swamps
        nearby, near the pond. And I… The stars from the sky are reflected in the water. It’s in my heart, I want to
        sob, I don’t want to weep, but just sob, and now, well, everyone has their own way. I have this, “AAAA, AAAA.”
        <br />
        <br /> Well, I say, you can't invent this scream on purpose, but I'm screaming like this as if it really came
        from inside me. Because I feel so bad in my heart. And this is what you need first, this scream, and then you
        not just cry, but you sob. And then, really, this kind of lightness comes, as if you just came into the world,
        such a feeling.
        <br />
        <br /> It even happens that we have a waste dump at our mine, well, just 300 meters. I come there either myself,
        or with someone, and here I am. I just stand and “AAAAA.”
        <br />
        <br /> Well, but it’s true, I am like that, well, in my childhood I was like that, well, that is, everyone
        laughs: “Tania, you are still a child.” I can be like that. They offended me, like, the chief engineer yelled at
        me, I sit down like this... Well, that’s all. I’m a girl, I’m a little girl, I’m Tania. Maybe because they loved
        me so much when I was a child, because maybe everyone loved me there, well, I can’t explain it. But I am happy,
        I don’t know, I really get up in the morning, I am happy about this day. Here we go, for example, for me, the
        most precious gift is the gift from the heart. So we were driving somewhere, Vitalik stops here, this is a field
        of wheat, he says, “I’ll be back right now.” He brought this spikelet to me, I say, “AAAA, how cool.” I really…
        Well, I’m glad that I know how to rejoice at this.
      </ChapterText>
    ),
    watchmaker: (
      <ChapterText>
        Olga, clock repairer, Odesa
        <br />
        <br />
        <br />
        I was then... probably 8-9 years old. As soon as I went to school, it happened that I took the clock apart.
        That's when I started to disassemble clocks. Somewhere something broke in the clock, the spring flew out and all
        the wheels scattered in different directions. Dad and I would come and take the clock to the workshop for
        repairs, here on the corner of Lenina and Kirova streets. Through the window, I watched the clock repairer
        sitting and working, well, disassembling and assembling clocks.
        <br />
        <br />
        Yes, I looked through the window straight into the workshop. There were large glass windows, and I could see
        everything. A table was right in front of the window. One could see how the repairer took the clock apart. We
        brought here a clock, which I broke as a child. Apparently, we come here often, because when I came to this
        workshop, I got there, I recognized this place. I did an internship there, and then, when my dad came there with
        me, he said, “We came to this workshop.” And then, I became a clock repairer in this workshop.
        <br />
        <br />
        It turns out that I worked there for 17 years. Yes, yes, 17 years.
        <br />
        <br />
        Now there are many clocks at home, three in each room. On every wall, on every shelf. But I should mention that
        some are too slow, the others are too fast. Their time is not accurate. As they say, a shoemaker’s children go
        barefoot, and a watchmaker has no proper watch.
        <br />
        <br />
        Even in the kitchen, there are three clocks, on each wall, because you have to look there, there is a clock next
        to the stove, and there is a clock on the fridge on a magnet too, you open the fridge, and you look at the time.
        We even put a clock in the bathroom to see the time. Yes. Well, there it is on a suction cup, it is attached to
        the tile, protected from moisture, but you also watch the time.
        <br />
        <br />
        When I was a child, there were many clocks, too. There were cuckoo clocks, there were weight clocks, and there
        were striking clocks. Dad went on trips for work and brought either alarm clocks or clocks from every city.
        There were lots of mantle clocks, well, they still remain.
        <br />
        <br />
        Well, for example, there are floating hands, they move smoothly. And there are the hands that twitch. Every
        second, they are like this, and you usually observe how the wheels go down, how the hands are spinning, and what
        kind of workings there are in the clock, backlash because when you release this trigger mechanism with the hands
        to unwind the spring, you watch the hands... Sometimes, they are evenly untwisted, and sometimes they make a
        figure-eight pattern. Now, if, for example, the hands go at random, it means that there is an overwork
        somewhere. So, you look what overworked, either the panel or the detail itself. Well, because the profession is
        somehow connected with the clock, and the clock is just to know the time, not to be late somewhere.
      </ChapterText>
    ),
    shepherd: (
      <ChapterText>
        Bogdan, meadow in the mountains, Lisnivsky ridge, Carpathian Mountains
        <br />
        <br />
        <br />
        That stone cross? There was a man, a shepherd.
        <br />
        <br />
        In spring, he agreed, let’s say, with someone like me, and they hired him for the summer. When he left home, his
        wife said, “May thunder kill you.” This is what she said. And she said it in a special moment.
        <br />
        <br />
        The end of the summer came, there were three heifers left, he had to go home.
        <br />
        <br />
        But he still stays, he says, “There are three heifers left, people will come tomorrow.”
        <br />
        <br />
        The rain started. It rained, and he… There was a spruce. He stood under a spruce tree, and the lighting struck –
        and killed him. His wife took the body home, and then bought this cross
        <br />
        <br />
        It’s an old cross, it was in… If I’ve been for 31 summer here… And then, it was 10-15 years before me. This
        cross was installed about 50 years ago.
        <br />
        <br />I could not understand what was written there. It has already fallen 2 times. It’s carved in stone.
      </ChapterText>
    ),
    wool: (
      <ChapterText>
        Petro Kopalchuk, Yavoriv village, Carpathians
        <br />
        <br /> <br />
        In a word, our family, Kopalchuk. The name come from “kopal”. This man was, well, an illegitimate son. You
        understand. Dovbush used to be somewhere there. And he went, well, everywhere. In Romania, and in England. He
        passed everywhere. And so in Transcarpathia, well, there was a family. There was such a good host, and he had a
        daughter. And he fell in love with that daughter, and she got pregnant. All the relatives drove this daughter
        away, drove her out of the house. Because she got in touch with this robber. And there was a Greek. I don’t know
        why he was called this name, maybe he came from somewhere in Greece, maybe just Grygoriy, well, he just had that
        street name Greek. He was rich, all these lands belonged to them, this corner. So, they adopted children.
        <br />
        <br />
        He was so strict that all these adopted children could not get along with him. And everyone went away. There he
        had a stable for the cattle. Well, this girl came, and there the labor started, and she gave birth quietly. So,
        he says, “Once God sent this child here, I take this child for my own.” Well, I don't know what happened to this
        woman next, she stayed there for a while, maybe I don't know her story, but this Greek kept a child. He adopted
        him, officially, probably immediately. And the priests first did not want to baptize the child. Well, fine, he
        was not baptized for 10 years, you know. They called him Kopyl. Well, he was an illegitimate child. Here we call
        such children “Kopyl.” And from this came the Kopyly family name. All Kopalchuk came from there, you know. And
        nowhere else this surname exists, although I have been everywhere in Ukraine.
        <br />
        <br />
        And then, this son, this Kopyl, got married, and he had 10 sons. Yes, he had 10 sons, here, and in Rizhny, and
        in Gribka, and in Kolomyia, the family is so scattered, you know. Not everyone knows who is where. There are
        relatives, and they inherited nothing from this well-off man, it passed on to strangers. Well, and they went to
        court. The trial has begun, and the trial was in Kolomyia. The trial is for that date, one person came, another
        did not come, but the money is still to pay for everything. And he was already exhausted at his farm, but he
        already sold what he had, he sold all the cattle there. It was because of the trial. Every meeting, everything
        was paid. And it came to the point that he was going to Kolomyia for the last time. He rode a horse. He still
        had this beautiful horse, he rides, and a man comes, and says, “Why are you so run-down?”, And he says, "There
        is this and that in court." “Give me your horse, then you will win the case,” that man says. He said, “I don’t
        know. It’s to discuss with the wife, and to find this Verkhovynsky.” He comes and says to his wife: “Maria, here
        is the case,” he says, “if we win, we will get a new horse. And if we lose, this horse will not save us anyway.
        Give me this horse.” And he found Verkhovynsky, gave this horse away and won the case. And so he kept all the
        fields.
        <br />
        <br />
        Sometime around 1760. 1770, probably, because in 1745, Dovbush was executed. Well, he was already an adult man.
        Yes, there is such a thing. Since then, all the generation lives here. It is also here, one Kopalchuk’s house,
        another Kopalchuk’s house, and there behind the eating place there too, my brother was baptized there. In Rizhny
        there are too, in Kolomyia there are, so much scattered.
        <br />
        <br />I had one brother and three sisters. One sister is still alive, and two aren’t. One died this winter.
        Another in 1997. The youngest was born in 1947, and me, in 1941.
      </ChapterText>
    ),
    lighthouse: (
      <ChapterText>
        Stanislav Semenovych, the Tendrivsky lighthouse keeper, 39 years in the lighthouse, Tendrivska spit
        <br />
        <br /> <br />
        I graduated from a maritime college. I have been abroad since I was 17. I have traveled around almost all
        European countries. I have been to Cuba and those regions. And in Asia, in Thailand, these places, the Indian
        Ocean. We sailed through the whole Atlantic Ocean. When I still studied, we monitored the Bermuda Triangle.
        Planes, ships, and submarines disappeared there. When you go to Cuba, you pass the Bermuda Triangle along the
        course. These are the Bermuda Islands, and there is the Bermuda Triangle. We passed it. We went there and went
        back. Some anomalies. Nobody found anything. Anything... how should I say? Either the earth’s crust cracked and
        everything goes down, or something related to space.
        <br />
        <br />I saw a world that did not fit my worldview. I saw two worlds: the world of “my country” and the world
        abroad. The worlds were completely different. Those worlds, let’s say, Europe, Belgium, Amsterdam, Rotterdam...
        For some reason, in the Soviet Union, when people came to an ordinary store, potatoes cost 12 kopecks, but
        rotten potatoes. Everything. Good potatoes and rotten ones cost 12 kopecks. When abroad, it was like here eggs
        are laid out in containers, this is how potatoes stand. One price is for good potatoes. Another price, well, a
        little cheaper, for different quality. The third price is even cheaper. There is a choice. Here, you count enter
        a store. There are rotten potatoes, you start to pick, and they yell at you in a foul language: “Stop picking,
        buy all potatoes”. That’s it. Believe me, in my time, it was like this. Do not pick, take everything. There was
        a different way of life. Abroad, you enter the store, you have to say hello, and they treat you with respect.
        They tell you, “What would you like to have?” Everything is for you; can you believe it?
        <br />
        <br />
        My first journey was when I was 17 years old. And so on. Then, there was simply no department for me to go, and
        I ended up serving, well, I had to. At that time, if you didn’t serve in the army, then you were considered ill
        or something. The girls did not like you if you did not serve, well, let’s put it this way, yes. If he was not
        in the service, it’s that he was somehow inferior. It was imperative to serve. It was possible to take time off,
        but I did not fall for it, because every self-respecting guy had to serve. I got to the Black Sea Fleet. I was
        sent to work with some secret communications equipment as a mechanic. I was admitted to equipment of special
        secret importance. They canceled my visa, and I was not allowed to go abroad for five years. Until they invent
        something new or I forget what I learned. It was a common practice at that time. In five years, new equipment
        appears, the old is discarded. What I knew is not relevant anymore, it is no longer in service.
        <br />
        <br />I have been here since 1981. January 16, 1981. I served and then stayed to work at the lighthouse.
        <br />
        <br />I was tired of the world. I cannot say anything more specific. When I stayed here, the reason was
        personal, for me to stay here to work... I met Sveta... I couldn't go abroad for five years. But within five
        years, I met her, within five years I got married, within five years, everything is here. The visa was canceled,
        that’s it, that’s all.
        <br />
        <br />
        This solitude, not everyone can withstand it. Starting from winter, well, in October, someone still comes here,
        and for November, December, January, February, mid-March, our team was four people. On the ship, there are at
        least 15-20 people for half a year, you can come and go to the port, and here, four people. Who are already fed
        up with each other, like, “I cannot stand you anymore.”
        <br />
        <br /> <br />
        Svitlana, the daughter of the previous lighthouse keeper, the wife of the current lighthouse keeper, 50 years on
        the lighthouse
        <br />
        <br />
        <br />
        Parents left, Slavik remained the boss. My father loved order, so we keep the tradition, we do not change it.
        <br />
        <br />
        We are the only people on the island who have not gone anywhere, we are constantly here.
        <br />
        <br />I used to swim in the sea, I swam all year round both in winter and in summer. And then, there was a
        border guard. He did not drink much, he was a family man. He drowned. His body was immediately found, and a life
        jacket was tied to his leg, it was tied, you know, with a sea knot...
        <br />
        <br />
        From that moment on, I do not go into the sea... I'm afraid that someone will emerge.
        <br />
        <br />
        Look at the dolphins now. Look, look, look. There, there, there are dolphins. Can you see them?
      </ChapterText>
    ),
    honey: (
      <ChapterText>
        Hustym, honey harvester, the village of Kopyshche, Polissya
        <br />
        <br /> <br />
        I was alone because my father was killed, my mother was killed, and my sisters were killed. And I remained
        because I went to the West. Here is Western Ukraine. I went away with two other boys in the spring. They hired
        us to graze their cattle. We had a big family, there was nothing to eat like that, somehow it was like that,
        hunger, yes. Sometimes there was not enough food. The three of us got together and went to Western Ukraine
        leaving Glushkovychi behind. Glushkovychi was Russia, and then Western Ukraine. Then the three of us went. Here
        we go, we cross the border, the Polish border was in the woods behind Glushkovychi. Once there was a border,
        when there were Poles. They were no longer there. We cross the forest, go from one village to another, and we
        look in the villages. They send us from one village to another, then one boy stayed on one farm, the second boy
        on the second, and I stayed on the third one, the village is called Kurman.
        <br />
        <br />I went to a guy, they are sitting in the house there. I came and said, "Do you need a shepherd?" Where are
        you from? From Kopych. And how are you, where is your father, where is your mother? They are looking for someone
        to graze cattle. I say, we have a big family, there is nothing to eat. Well, stay with us. Well, I stayed to
        graze cattle, then, I stayed there until the summer. There were sheep, calves, oxen. The cows were there. The
        owners kept a lot of cattle like that.
        <br />
        <br />A partisan comes, he calls me by name. He recognized me. He says come here Ustim. I'm coming. “You will
        have to work, boy, because your father and mother were killed. Your father is dead, your mother is dead, they
        are killed by the Germans.” Oh what I am saying. I tell them, let me go home, because Uncle Ivan Grechka, the
        partisan, was passing by, and he told me that my father and mother were killed. Then go and see. Well I then
        told the boys at the farm. I told one and the other, we ran. We arrived there in the evening, and I see that the
        air in Glushkovychi is so bad, it smells like this, like the burnt blood. Such was the air. Bad, impure. I came
        to that place, went to the house. There was nothing. I came across a skull of a child. I saw what the child was
        burned, killed. I put it in a hole, covered with grass, wrapped, because they could eat the body. Yes, I cried,
        I cried, I asked the old women from the village there. I asked only to spend the night and to go away, and they
        did not take me. I went back. She told me, go graze the cattle. And these two boys who were with me, they have
        relatives left. I went back to that village myself. I stayed with them until spring. He says, “Go to Kopyshche
        from us. We don't need you. Your partisans have already eaten everything.”
        <br />
        <br />
        They gave me a small calf on a string, put some bread in a bag, two shirts, linen trousers, they gave me a
        tunic, bread in a bag, and there is a guardian angel for sure. The calf goes like a dog after me, it follows me.
        I take the bread for it and feed it. Then it eats grass, because the grass was there, it was still warm, just
        think of going somewhere in that village, it's very far away. Yes, I ran to Glushkevychi, after Glushkevychi we
        went to the forest, our whole village. Yes, I crossed a ditch, and the calf followed me on a string. Well, is it
        possible now to hand over the calf, it tears your arms around, it jumps. And then, he goes with me on a string!
        I don't know what force held him. Who held him. The angel! The Lord. And it obediently follows me. That was it.
      </ChapterText>
    ),
    salt: (
      <ChapterText>
        Oksana Bunda, technologist, Drohobych Saltworks, Drohobych city
        <br />
        <br />
        <br />
        I love this plant so much, so much. You know, for me to come here, that's the most precious. I am very happy. It
        looks like St. George’s Church and the Church of the Exaltation of the Cross, have you seen it? If we connect
        them, our mine is on this line. This is where it is located. And here is mine number 2. Under the tile. If you
        connect mine number 2 and mine number 1, then an intersection is formed, a cross which lives its own life. Why
        do I say it? Because this brine is constantly flowing and filling this mine. One can hear how it flows. Did you
        hear how it flows there? Oh, you’ve heard. And yes, we take it out, we pump it out.
        <br />
        <br />
        600 years, yes. In 83-84, they just cleaned the silt. And I was lucky enough to go down to the bottom.
        <br />
        <br />
        It was like this. The miners came, and they were specialists in cleaning the bottom. This is called unit. And so
        they cleaned it, pumped it out, however, first, all the brine, then cleaned, and just put me there, I say, “I
        really want to see what’s there.” They gave me a protection wear, because you can't just go down, and I went
        down and looked. I remembered it for the rest of my life. Because you see how neatly it’s done. There is a cage
        that we opened, yes. And there are such railings. For each floor, 1st, 2nd, 3rd, to the very end. About 12
        floors overall.
        <br />
        <br />I remembered that it was easy for me to go down, I didn’t feel tired, maybe I was just so curious, on the
        rise, yes. And it was quite easy for me. I was very pleased when I got up.
        <br />
        <br />
        Look here. Here before, 20 million years ago, when there was a Lower Neogene, Miocene period, there was a sea.
        When the Carpathians began tectonic processes, young mountains, the Neogene period, began to rise, the sea
        receded, and formed smaller lagoons. And in them with such a climate, the climate type is called arid, there was
        a lot of intense evaporation. Salt settled. It crystallized. Salt is a mineral. The mineral we eat. But it is
        called in Greek, halite. Here, that halite, it was just deposited. It went further, it is so solid, and here it
        formed the lenses of that halite, mixed with clay and gypsum.
        <br />
        <br />
        You know, I’m already deep into this, and every time I got to know it better, this plant, you know. At first
        yes, well, just a factory, a plant, and then I saw what those churches are really there. I took a map, I look at
        them, and that's how I think, well, I just look, so I take a pencil and draw a line between those churches, I
        think why they are all on the same line, you know. Then the first mine, the second mine, for sure, it made an
        intersection. Shivers went down my spine. The only mine left. They wanted everything, they moved the garages,
        they wanted to destroy it all, you know, they wanted to close the plant altogether. And yet you see, the mine
        still remained.
      </ChapterText>
    ),
  },
  uk: {
    mine: (
      <ChapterText>
        Таня Агапова, начальниця Дільниця Технологічного Комплексу Поверхні, Торецька шахта, місто Торецьк
        <br />
        <br />
        <br />
        Есть ли у кого-то в нашем городе любимые места? У меня вот даже нет, я люблю свой город, и у меня нет любимого
        места. Но это ж после этого уже. От то есть куда ты можешь прийти, да, и вот побыть наедине со своими мыслями.
        Один только мне сказал, ну если вы у нас проезжали, там сейчас написано «Торецьк — місто шахтарів». И вот он
        говорит: «Я рано утром поднимаюсь туда, сажусь, — говорит, — тишина, ручеечек какой-то еще течет».
        <br />
        <br />Я такая, мне нравится по лесу вот это, и в любое время года. Осенью даже как ДДТ: «Что такое осень — это
        небо» это разбрасывать все ж. Ну, то есть любая природа, главное, чтобы я подпиталась от природы.
        <br />
        <br />
        Вот дома вот сижу, я ж понимаю, что мне плохо. Это очень-очень редко бывает. Вот как-то все вот это, вот все
        навалилось, и все. И вот я сижу дома, на меня давят эти 4 стены, я вот, ну, чего-то хочу, и вот я тогда шурую на
        природу. У нас есть это, Делеевка называется, пруды, они там вокруг такие хвойные чуть деревья, лиственные. И в
        этих хвойных деревьях, там, это надо знать место, там березки. Среди всего этого березки. Это настолько красота.
        Что подергивает. И вот я уже нашла себе эти места. Вот даже не было, звоню, такси вызываю, таксисту говорю: «Ты
        закрой окна, и посиди. Если я буду кричать, я ни топиться не буду, то есть не переживай, — говорю. — Дай мне
        побыть это самое, потом открывай, все».
        <br />
        <br />А вот я ж говорю, бывает, вот последняя точка, на какую-то мелочь, вот вроде шла, все плохо-плохо, шла,
        споткнулась, — и все, и вот это, например, последняя точка — от блин, еще и споткнулась там и пальчик ударила.
        Ну какая-то вот последняя есть капля, вот это что-то, и все там. Болота возле этого ж, возле пруда ж. И я, в нем
        звезды отражаются неба. Вот именно на душе, хочется вот зарыдать, вот именно не поплакать, а вот именно рыдать,
        и вот, ну, у каждого ж по-своему. У меня вот: «АААА, АААА».
        <br />
        <br />
        Вот я ж говорю, его специально этот крик не придумаешь, а вот именно, что я вот так кричу, как будто
        действительно он у меня изнутри идет. Вот настолько плохо на душе. И вот это надо сначала этот крик, а потом вот
        именно не просто плачешь, а рыдаешь именно. И потом вот действительно вот такая легкость наступает, вот как
        будто родился на свет, такое чувство.
        <br />
        <br />
        Бывает вот просто даже, у нас на шахте есть породный отвал, ну буквально метров 300. Я на него прихожу или сама,
        или с кем-то, и вот меня просто. Я просто стою и «ААААА».
        <br />
        <br />
        Ну, а правда же, я такая, ну, я вот в детстве была вот такая вот, ну то есть все смеются: «Тань, у тебя детство
        и осталось». Я могу, вот меня обидели, это самое, главный инженер накричал на меня, я села такая… Ну и все. Я же
        девочка, я же маленькая, я же Танечка. Может, потому, что меня сильно любили в детстве, потому что, может, меня
        все кохали там, ну я не могу это объяснить. Но я радуюсь, не знаю, я вот действительно утром встаю — я радуюсь
        этому дню. Вот идем, например, для меня подарок больше всего ценен, который от души сделанный. Вот мы ехали
        куда-то, Виталик тут это останавливается, это поле с пшеницей, он говорит: «Щас я». Он мне колоски эти притащил,
        я: «АААА, класс». Я действительно, ну, я радуюсь, что я умею вот этому радоваться.
      </ChapterText>
    ),
    watchmaker: (
      <ChapterText>
        Ольга, годинникар, Одеса
        <br />
        <br />
        <br />
        Мне тогда лет было... наверно, лет 8–9. Я как только в школу пошла, вот получалося, шо я часы разбирала. Вот
        когда начинаю разбирать или где-то что-то там ломалося в часах, вылетала пружина и все колеса разбегались в
        разные стороны. Мы приходили с папой, относили часы на ремонт в мастерскую, вот Ленина угол Кирова. И через окно
        я смотрела, как сидит часовой мастер и занимается, ну, разборкой-сборкой часов.
        <br />
        <br />
        Да, через окно прямо в мастерскую. Были большие окна стеклянные, и все было видно, прямо стол стоял перед окном.
        И было видно, как вот он разбирал. Приносили вот сломанные часы, которые я поломала в детстве. И в итоге часто,
        видимо, ходили, потому что, когда я уже пришла в эту мастерскую, попала именно туда, это я уже потом вспомнила.
        Потому что я там проходила практику, и потом, когда папа со мной туда пришел, и говорит: «Мы вот приходили в эту
        мастерскую». И я вот в этой мастерской стала часовым мастером.
        <br />
        <br />
        Получается, там 17 я лет проработала. Да, да, 17 лет.
        <br />
        <br />
        Сейчас дома именно много часов, по 3 пары в каждой комнате. На каждой стенке, на каждой полочке. Но сам факт,
        что они одни отстают, вторые спешат, неправильно ходят. Как говорится, сапожник без сапог, а часовой мастер без
        часов.
        <br />
        <br />
        Даже в кухне 3 пары часов, на каждой стенке, потому что надо туда посмотреть, возле плиты часы стоят, и на
        холодильнике часы на магните тоже, открываешь холодильник, смотришь время. И даже в ванную комнату поставили
        часы, чтобы тоже смотреть, сколько времени. Да. Ну там они такие на присоске, к плитке крепятся, защищенные от
        влаги, но тоже смотришь время.
        <br />
        <br />В детстве тоже много, были часы с кукушкой, были ходики, были часы с боем. Потому что папа ездил по
        командировкам и привозил с каждого города или будильники, или часы. Настольных очень много было, ну они и до сих
        пор остались.
        <br />
        <br />
        Ну вот есть, допустим, плавающие стрелки, они плавно текут. А есть те, которые дергаются. Вот каждую вот
        секунду, вот есть такие вот, и обычно наблюдаешь, как идет спуск колес, как крутятся стрелки и какие там есть
        выработки в часах, люфты, потому что, когда со стрелками спускаешь этот пусковой механизм, чтобы раскрутить
        пружину, наблюдаешь за стрелками. Они бывают ровно раскручиваются, а бывает, идут восьмеркой. Вот если,
        допустим, стрелки идут вот так вот криво-косо, значит, где-то уже есть выработка. Уже смотришь там в плате
        выработка или в самой детали выработка. Ну потому что профессия как бы связана с часами, и на часы время только
        нужное посмотреть, куда-то не опоздать.
      </ChapterText>
    ),
    shepherd: (
      <ChapterText>
        Богдан, полонина в горах, Ліснівський хребет, Карпати
        <br />
        <br />
        <br />
        Той кам’яний хрест? Там був мужик, худобу пас.
        <br />
        <br />
        Навесні він згодився там допустим так, як за мноу, і я його наймив на літо, він з дому йшов, а жінка каже: «Грім
        би тебе вбив». Сказала так. І в таку, в таку мінуту.
        <br />
        <br />
        Він пішов вже від літу, лишилося три телички, він вже мав додому йти.
        <br />
        <br />
        Но він ще лишається, каже: «Три телички лишились, люди прийдуть завтра, та ясь».
        <br />
        <br />
        Дощі пішли. Пішли дощі, і він, там смерека була. Він став під смерекою, і грім вдарив — і все, вбив. Жінка
        забрала додому, а потом отой хрест прикупила
        <br />
        <br />
        Та то старий, то десь роки були… Якшо я вже 31-ше літо тут. А то ще до мене, десь років може 10–15. Десь вже є
        коло 50 років доходе. Як той хрест поклали.
        <br />
        <br />Я не міг то зрозуміти, що там написано. Він вже 2 рази падав. То ж камінь то віреблений, то не є скаяний.
      </ChapterText>
    ),
    wool: (
      <ChapterText>
        Петро Копальчук, село Яворів, Карпати
        <br />
        <br /> <br />
        Одним словом, рід наш, Копальчуки пишемось. Копальчук от слова копал — це, ну, незаконнонароджений, байстрюк
        так. Розумієте. Це колис ще Довбуш був десь там. А він ходив, ну, скрізь. І на Румунії, і в Англії, і скрізь
        проходив. І так шоб на Закарпатті, ну, там була така родина. Гарний господар такий був, і була дочка. І він ту
        дочку покохався, і вона завагітніла. І всі родичі прогнали цю дочку, з дому прогнали її. Через то, шо з цим
        розбійником зв’язалась. А там був Грек такий, чому називався, може, десь з Греції, може, просто Григорій, ну
        таке вуличне прізвище Грек. Він був багач, всі ці землі — це їм належали, так оцей куток, і взяли прийомних
        дітей.
        <br /> <br />
        Був такий строгий, шо всі ці прийомні не могли з ним ужитись. І все ходили. А там у нього була така стайня, щоб
        худобу загнати. Ну ця дівчина йшла, і там на неї напали роди, і та тихо родила. І він каже: «Раз так Бог дав, шо
        це родила, беру цю дитину за свою». Ну і вже не знаю історії цієї жінки, вона трохи там побула якийсь час, там,
        може, не знаю, шо з нею сталося, але дитина лишилась у цього Грека. Він перейняв, та й усиновив, офіційно,
        певно, відразу. І священики враз не хотіли охрестить ту дитину. Ну і так ні хрещений, ні хрещений, до 10 років
        було так, знаєте. А назвали, як називали, Копил. Ну байстрюк, знаєте так. По-нашому Копил. І від цього пішли
        Копили. Всі Копальчуки пішли з цього, знаєте. І більше ніде цього прізвища, скіко я був скрізь в Україні.
        <br /> <br />І цей потом уже син, Копил цей, одружився, всьо, мав 10 синів. Да, мав 10 синів, і тут є, і у Ріжні
        є, і у Грібці є, і в Коломиї є, є родина така розпорошена, знаєте, вже так. Не всі знають, хто де. Родичі є, а
        їм нічого не впало з цього добра хазяїна, перейшло на чужих. Ну і знайшовся, судили його. Розгляд почався, а суд
        у Коломиї. Поклич на це число, один прийшов, один не прийшов, то так гроші капають. І він так уже вимотався з
        свого господарства, але вже шо мав, то продав, худобу там всю порозпродав. Цей суд короче дав. Кожне засідання,
        все оплачувалось. І дійшло до того, шо він уже їде послідній раз у Коломию. Верхом на коні їхали. Гарний кінь у
        нього ще був цей, їде верхом, і йде якийсь чоловік, каже: «Шо ти такий замужряний?», а він ка: «Та то така
        справа», — каже. «Віддай мені свого коня, то ти виграєш справу», — каже. Він ка: «Я знаю. Порадься з жінкою,
        сказав, де найди цього Верховинського. Він приходе, да й каже жінці: «Марійка, то така справа, — каже, — якшо ми
        виграємо справу, то ми ще коня придбаємо такого, як треба. А програємо, то цей кінь не врятує і так. Давай цього
        коня». І він знайшов Верховинського, віддав цього коня і виграв справу. І так всі поля залишились уже за ним.
        <br /> <br />
        На 1760-й рік приблизно. 70-й мо, бо 1745 року Довбуша стратили. Ну то вже був дорослий чоловік. Да, така справа
        є. І з того часу тут все поколєніє живе. Це теж тут, одна хата Копальчуки, друга хата Копальчуки, і там за
        харчевнею там тоже, там вже брат був мій хрещений. У Ріжні є тоже, в Коломиї є, розпорошені вже так.
        <br /> <br />
        Один брат був у мене, три сестри. То ще одна живе, а дві нема. Одна вмерла цієї зими. Інша у 97 році. Наймладша
        з 47-го року живе, да і я з 41-го.
      </ChapterText>
    ),
    lighthouse: (
      <ChapterText>
        Станіслав Семенович, наглядач Тендрівського маяку, 39 років на маяку, Тендрівська коса
        <br />
        <br />
        <br />
        Я закончил мореходку. Я с 17-ти лет уже заграницей был. Почти всю Европу объездил, на Кубе был, те края. И в
        Азии, в Таиланде, то такое все, Индийский, Атлантику переходили полностью, проходили как-то, еще в мое обучение
        следили за Бермудский треугольником. Я видел мир, который не соответствовал моему мировоззрению. Я два мира
        видел: мир «моя страна» и мир за рубежом. Миры абсолютно разные были. И те миры, которые, допустим, Европа,
        Бельгия, Амстердам, Роттердам… Первый рейс мой был в 17 лет. Ну и так дальше. А потом просто не было кафедры, и
        я попал служить, ну надо было. На то время, если не служил, то ты или больной, в общем, девки не любили, если не
        служил парень, ну вот так скажем, да. Раз не был на службе — значит какой-то неполноценный. Обязательно было
        служить. Попал на Черноморский флот. И попал механиком засекречивающей аппаратуры связи. Был допущен к
        аппаратуре секретной особой важности. Все и визу закрыли, за границу на 5 лет не взяли. Пока они что-то новое не
        изобретут или я не забуду то, что я знал. Так положено было на то время. По истечению 5 лет новая техника
        появляется, старая списывается, а я знал старое, оно уже не стоит на вооружении.
        <br />
        <br />Я здесь с 81-го года, 16 января 81-го года. Я служил и потом остался работать на маяке.
        <br />
        <br />
        Надоело этот весь мир. Конкретно я не могу сказать. Я когда остался работать, причина была моя, чтобы я остался
        здесь работать... Свету встретил… Мне нельзя было пять лет выходить где-то за границу. Но в течение пять лет
        познакомился, в течение пяти лет я женился, в течение пяти лет все тут. Визу закрыли, вот так, и вот и все.
        <br />
        <br /> <br />
        Світлана донька минулого наглядача маяку, дружина теперішнього наглядача, 50 років на маяку
        <br />
        <br /> <br />
        Родители уходили, Славик начальником остался. Отец любил порядок, так мы его и продолжаем мы традицию не меняем.
        <br />
        <br />
        Мы единственные на острове которые никуда не уезжали, мы постоянно здесь.
        <br />
        <br />
        Раньше я купалась в море, круглый год купалась и зимой и летом. А потом тут пограничник был. Сам и не пил
        сильно, семейный был. Утонул. Его тело сразу нашли, а к ноге был привязан жилет спасательный, и привязан, знаешь
        морский узлом…
        <br />
        <br />С этого момента я в море не захожу...Боюсь что кто-то всплывет.
        <br />
        <br />
        Все смотри дельфины идут. Смотри, смотри, смотри. Вон, вон, вон дельфины. Видишь?
      </ChapterText>
    ),
    honey: (
      <ChapterText>
        Густим, бортник, село Копище, Полісся
        <br /> <br />
        <br />Я остався сам, бо батька вбили, мати вбили, сестрів побили. А я остався через шо, бо пішов на Западну. Тут
        Западна Україна. До дядька я і ще 2 хлопчики такие на весні пошли. Пасти їх худоби, у найми. Бо сім’я була у нас
        велика, нема чого їсти тако, якось так було, голод таке. Було таке, шо не хватало. Зібрались ми втрьох і пішли
        на Западну Україну за Глушковичи. Глушковичи — це була Росія, а далі вже Западна Україна. То ми пошли втрьох.
        Ідем, переходим границю, польська була границя у лісі за Глушкевичами. Колись була границя, ще була, поляки да.
        Це вже не стало їх. Та переходим лесом-лесом, ідем на один хутор по селу, а ми у хуторах шукаєм. Нас направляють
        з одного хутора до другого, тоді зостався на одному хуторі, другий хлопець на другому, а я остався на третім,
        пішов, хутор Курман називається.
        <br />
        <br />
        Заходю до дядька, сидять вони в хаті там. Прийшов, кажу: ну вам пастух треба? Откуда ти? С Копич. А як же ти
        сам, батько є, матір є? Вони тебе шукають, шоб пасти худобу. Я кажу, у нас сім’я велика, нема шо їсти. Ну то
        оставайся в нас. Ну я остався пасти худоби, то я в них так побув до літа. Були овечки, телята, воли були. Корови
        були такі. Хазяїни чимало худоби так держали.
        <br />
        <br />
        Коли їде партизан, да гука меня на ім’я. Обізнав мене. Каже ходи сюда Устім. Я приходю. Вже синок будеш ходити
        по наймах, бо батька й мати вбили. Нема батька твого, матір, побили немци. Ох я заганяю то. Да кажу пустіть мене
        додому, бо їхав партизан дядько Іван Гречка, да сказав мені, шо вбили батька й матір. То йди і побачиш. Добре я
        тоді сказав хлопцям на хутор до обіду. Одному і другому сказав, побігли ми. Прибіга вже на вечір, і бачим, шо за
        Глушковичи села такий воздух недобрий, таке пахне таким кров погоріла, де люди. Такий воздух був воздух.
        Недобрий такий, нечистий. Прийшов я на то місце, пішов у хату, нема. Прийшов я якось черепка із дитяти. Бачу, шо
        спалене таке, убите, поклав в ямку, прикрив травою, загорнув, бо ще з’їдять. Да поплакав, поплакав, да попитав
        там у бабушок з села. Тьотка мені баба да переночувать да похать, а вони мене не беруть, пішов геть назад. Каже,
        нема іди назад, то будеш пасти. А два етіх хлопця, шо за мною були, у них родня осталася. Пішов я сам назад туди
        в те село. Перебув я в них до весни. Каже, іди ти в Копищі вже од нас. Ти нам не нужний. Ваші партизани вже все
        поелі.
        <br />
        <br />
        Мне причепили отакого бичка невеликого на шнурок, хлеба вклали в торбу, сорочки дві, штани две полотняні, дали
        свиту, хліба в торбу, і ви не думайте тож есть такий ангел-хранитель. Телятко йде, як те собаченя за мною, куди
        я — туди й воно. Я вийму той хліб їм, і йому дам. То воно траву їсть, бо трава була, ще тепло, де то подумай, де
        то зайди в те село, то ж вельми далеко. Да пробігся у Глушкевичи, за Глушкевичами ми всім селом да в лес. Да
        прийшов ще через канаву, і те теля зі мною на шнурку іде. Ну хіба ж можна тепер те теля завести почепить на
        машину здавати теля, воно тобі рве руки кругом, скакає. А то зі мною на шнурке йде! Я не знаю, яка сила його
        держала. Хто держав. Ангел держав! Господь. І воно слухняно йде за мною. Ото таке було.
      </ChapterText>
    ),
    salt: (
      <ChapterText>
        Оксана Бунда, технолог, Дрогобицька солеварня, місто Дрогобич
        <br />
        <br />
        <br />
        Я так люблю цей завод, шо я просто. Ви знаєте, для мене ото прийти сюди, це всьо. Я дуже рада. Це дивиться,
        церква Святого Юра і церква Воздвиження Хреста, ви бачили її? Оце їх з’єднати, то наша шахта на цій лінії. Прям
        отак розташована. А це шахта номер 2. Під черепицею. Якщо з’єднати шахту номер 2 і шахту номер 1, то утвориться
        таке пересічення, утвориться такий живий хрест. Чому я кажу живий, тому шо постійно оцей розсіл тече і наповнює
        цю шахту. І чути, як тече. Ви чули, як там тече? Чули, о. І так, ми вичерпуємо, ми його викачуємо,
        <br />
        <br />
        Оце будівля стара, оце нижня частина, це в 1473 році введена в експлуатацію. Ця шахта. Вона зроблена із таких
        дубових брусків, вона не є скріпленою цвяхами, залізо не застосовували, тому шо залізо то антагоніст. Бачите як.
        Оці металоконструкції залізні, то всьо проржавіло. Через сіль, да. Сіль. Оця шахта тоже під черепицею, це тоже
        будівля. Розсолозбірник були оце в середині, куди закачується цей розсіл. Повністю такі дерев’яні. Це 1838 рік.
        <br />
        <br />
        600 років, да. Тільки у 83–84-му році тільки чистили мул. І я якраз мала поки щастя туди на саме дно спуститися.
        <br />
        <br />
        Це були, приїхали гірники, і вони спеціалісти по цьому були, щоб почистити оце дно. Це називається забой. І от
        вони почистили, відкачали, правда, спочатку весь розсіл, потім почистили, і якраз мене туди, кажу: «Хочу дуже
        подивитись, шо там». Мені дали костюм, тому шо так не можна просто спускатися, і я спустила подивилась. Я це
        запам’ятала на все життя. Тому шо як воно зроблено акуратно, розумієте. Є ходова клітка, яку ми відкривали, так.
        І там такі перила. І так кожен поверх, 1-й, 2-й, 3-й, так до самого кінця десь 12 поверхів.
        <br />
        <br />Я запам’ятала, що мені легко було спуститися, я не відчувала ні втоми, може просто було така дуже
        зацікавлена, на підйомі, да. І мені зовсім було легко. Я дуже була задоволена, піднялася.
        <br />
        <br />
        Ну дивиться. Тут раніше, 20 мільйонів років тому, коли був нижній неоген, міоценовий період, тут було море. Коли
        Карпати, почали тектонічні процеси, молоді гори, неогеновий період, міоцен, почали підійматися, море відходило,
        і утворювались мілкіші лагуни. І в них при такому кліматі, аридний називається клімат, коли дуже йшло інтенсивне
        випаровування, осідала сіль. Кристалізувалася. Сіль це є мінерал. Один мінерал, який ми їмо. Але він по-грецьки
        має назву гальця, галіт. От, і той галіт, він якраз відкладався, так просувався, він твердий такий, і отут він
        утворювався лінзи того галіту, перемішені з глиною і гіпсом.
        <br />
        <br />
        Представляєте, я вже так, і з кожним разом я його більше пізнавала, цей завод, знаєте. Спочатку так, ну завод,
        собі завод, а потім я побачила, шо дійсно ті церкви. Я взяла мапу, так дивлюся, і так мені шось в голову, ну
        дивлюся просто, так беру олівець і протягую лінійку між тими церквами, думаю, чого вони всі на одній лінії
        стоять, знаєте так. Потім я шахту першу, шахту другу, точно, воно так пересіклося. В мене аж мороз по шкірі
        пішов. Єдина шахта, яка залишилася. Хотіли всю, гаражі посували, хотіли зруйнувати, розумієте, хотіли взагалі
        завод закрити. І все-таки бачите, все-таки шахта залишилася.
      </ChapterText>
    ),
  },
}
